import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

export default function QrCode({ value, size = 240, className = '' }) {
  const [dataUrl, setDataUrl] = useState('')

  useEffect(() => {
    let active = true
    if (!value) {
      setDataUrl('')
      return undefined
    }
    QRCode.toDataURL(value, {
      width: size * 2, // doble resolución: nítido en pantallas de alta densidad
      margin: 2,
      color: { dark: '#16519D', light: '#FFFFFF' },
      errorCorrectionLevel: 'H',
    }).then((url) => { if (active) setDataUrl(url) })
    return () => { active = false }
  }, [value, size])

  // El tamaño es el máximo: en pantallas angostas se reduce manteniendo la proporción cuadrada.
  if (!dataUrl) return <div className={'aspect-square max-w-full animate-pulse rounded-2xl bg-background ' + className} style={{ width: size }} aria-label="Generando código QR" />
  return <img src={dataUrl} width={size} height={size} alt="Código QR de la credencial CSPAH" className={'aspect-square h-auto max-w-full ' + className} />
}